<template>
  <div id="app">
    <Header></Header>
    <transition name="router-anim">
      <router-view/>
    </transition>

    <Footer></Footer>
     
  </div>

</template>


<script>

import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'app',
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #333;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.router-anim-enter-active {
  animation: coming 1s; 
  animation-delay: 1s;
  opacity: 0;
}


.router-anim-leave-active {
  animation: going 1s; 
}

@keyframes going {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-50px);
    opacity: 0;
  }
}


@keyframes coming {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
